import type { FaireProductEntity } from "../../entity_types/product";

export const p_99d5vjs5e3: FaireProductEntity = {
  token: "p_99d5vjs5e3",
  type: "product",
  name: "LM-KSH-1010-Light Blue Mini Polka Dot KIDS SHORTS",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/3e12241471d2cb8e9f610e57851f27bfbb7c92d509c3db568f20ed70e19f543c.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.5,
  description: "Perfect for active kids, these lightweight boxer shorts deliver all-day comfort with breathable fabric that keeps up with playtime. Available in a vibrant range of colors to match every personality and outfit. Soft, stretchy material moves with your child while staying cool and dry. An essential wardrobe staple for summer adventures, school, or casual wear.\n\n100% cotton\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:50.133Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
